import React from "react";
import "../css/mainContact.css";
import strongArrow from "../img/portfolio/bordArrow.png";
import { useNavigate } from "react-router-dom";

export default function MainContact() {
  const nav = useNavigate();
  return (
    <section className="mainContact">
      <div className="mainContact_inner">
        <div className="title_wrap mainContact_wrap">
          <h3>CONTACT</h3>
          <strong>데이터파이브에 문의하기</strong>
        </div>
        <div className="mainContact_content">
          <h4>
            데이터파이브에 함께,
            <br /> 더 스마트한 내일과 하이파이브 하세요!
          </h4>
          <button
            onClick={() => {
              nav("/contact");
            }}
          >
            <span>문의하기</span>
            <img src={strongArrow} alt="문의하기 화살표" />
          </button>
        </div>
      </div>
    </section>
  );
}
